import { render, staticRenderFns } from "./head-menu.vue?vue&type=template&id=0b2da612"
import script from "./head-menu.vue?vue&type=script&lang=js"
export * from "./head-menu.vue?vue&type=script&lang=js"
import style0 from "./head-menu.vue?vue&type=style&index=0&id=0b2da612&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports